interface IOptionItem {
  id: string;
  [key: string]: any;
}
export const getStatusById = (option: IOptionItem[], id: string) => {
  return option.filter((item) => item.id === id)[0] || {};
}
